<template>
    <v-container class="ma-0 pa-0">
        <v-row class="py-10 px-8 pb-12">
            <strong>Filtros</strong>
            <v-spacer></v-spacer>
            <v-btn @click="removeFilter()" small class="elevation-0" style="border:solid 1px #dddddd;">
                <v-icon small class="mr-1">mdi-filter-off</v-icon>Limpiar
            </v-btn>

            <v-menu offset-y :close-on-content-click="closeDatePicker(company.created_at)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field :rules="[v => !!v || 'Campo requerido']" clearable required v-model="company.created_at" label="Fecha Creación" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="company.created_at" range></v-date-picker>
            </v-menu>

            <v-menu offset-y :close-on-content-click="closeDatePicker(company.updated_at)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field :rules="[v => !!v || 'Campo requerido']" clearable required v-model="company.updated_at" label="Fecha Edición" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="company.updated_at" range></v-date-picker>
            </v-menu>

            <v-text-field @keydown.enter="filter()" v-model="company.name" label="Nombre"></v-text-field>
            <v-text-field @keydown.enter="filter()" v-model="company.fiscal_address" label="Dirección"></v-text-field>
            <v-text-field @keydown.enter="filter()" v-model="company.phone" label="Teléfono"></v-text-field>
            <v-text-field @keydown.enter="filter()" v-model="company.email" label="Correo Electrónico"></v-text-field>
            <v-text-field @keydown.enter="filter()" v-model="company.rfc" label="RFC"></v-text-field>
            <v-text-field @keydown.enter="filter()" v-model="company.razon_social" label="Razón Social"></v-text-field>

            <v-select @keydown.enter="filter()" v-model="company.origins" :items="originLists" item-text="name" item-value="id" attach chips label="Procedencia" multiple>
            </v-select>

            <v-select @keydown.enter="filter()" v-model="company.status_id" :items="statusLists" item-text="name" item-value="id" attach label="Estatus" clearable>
            </v-select>

            <v-select @keydown.enter="filter()" v-model="company.users" :items="usersLists" item-text="full_name" item-value="id" attach chips label="Responsable" multiple>
            </v-select>

        </v-row>
        <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary"><!-- # d71182 -->
            <v-list-item link @click="filter()" dark>
                <v-list-item-content>
                    <strong>Filtrar (0)</strong>
                </v-list-item-content>
            </v-list-item>    
        </v-card>
    </v-container>
</template>
<script>
import axios from "axios"
  export default {
    data: () => ({
        company:{
            name:'',
            users:[],
            cities:[],
            origins:[],
            status_id:1,
            name:'',
            fiscal_address:'',
            phone:'',
            email:'',
            rfc:'',
            special_note:'',
            razon_social:'',
            created_at:[],
            updated_at:[],
        },
    }),
    computed: {
        usersLists(){
            return this.$store.state.user.salesman.map(id=>{return{
                ...id,
                full_name: id.name + ' ' + id.last
            }});
        },
        originLists(){
            return this.$store.state.origin.origins;
        },
        statusLists(){
            return this.$store.state.status.statuses;
        },
    },
    methods: {
        closeDatePicker(dates){
            if(dates!=null && dates.length==2){
                return true
            }else{
                return false
            }
        },
        removeFilter(){
            this.company = {
                name:'',
                agencies:[],
                users:[],
                cities:[],
                origins:[],
                status_id:'',
                fiscal_address:'',
                phone:'',
                email:'',
                rfc:'',
                special_note:'',
                razon_social:'',
                created_at:[],
                updated_at:[],
            },
            localStorage.removeItem("selectorFiltersAgencies")
            localStorage.removeItem("filtersAgencies")
            localStorage.removeItem("filtersAgenciesLength")
            this.$nextTick(() => {
                this.$emit("filterAgencies", false);
            })
        },
        filter(){
            var count = 0
            var filter = ''
            //abierto
            if(this.company.name!=''){
                count = count+1
                filter = filter + '&filter[name]='+this.company.name
            }
            if(this.company.fiscal_address!=''){
                count = count+1
                filter = filter + '&filter[fiscal_address]='+this.company.fiscal_address
            }
            if(this.company.phone!=''){
                count = count+1
                filter = filter + '&filter[phone]='+this.company.phone
            }
            if(this.company.email!=''){
                count = count+1
                filter = filter + '&filter[email]='+this.company.email
            }
            if(this.company.rfc!=''){
                count = count+1
                filter = filter + '&filter[rfc]='+this.company.rfc
            }
            if(this.company.razon_social!=''){
                count = count+1
                filter = filter + '&filter[razon_social]='+this.company.razon_social
            }
            //multiples
            if(this.company.users.length>0){
                count = count+1
                filter = filter + '&filter[user_id]='
                var length = this.company.users.length
                for(var i=0; i<length; i++){
                    filter = filter + this.company.users[i]
                    if(length>1 && i<length-1){
                        filter = filter + ','
                    }
                }
            }
            if(this.company.agency>0){
                count = count+1
                filter = filter + '&filter[agency_id]='
                var length = this.company.agency.length
                for(var i=0; i<length; i++){
                    filter = filter + this.company.agency[i]
                    if(length>1 && i<length-1){
                        filter = filter + ','
                    }
                }
            }
            if(this.company.cities.length>0){
                count = count+1
                filter = filter + '&filter[city_id]='
                var length = this.company.city_id.length
                for(var i=0; i<length; i++){
                    filter = filter + this.company.city_id[i]
                    if(length>1 && i<length-1){
                        filter = filter + ','
                    }
                }
            }
            if(this.company.origins.length>0){
                count = count+1
                filter = filter + '&filter[origin_id]='
                var length = this.company.origin_id.length
                for(var i=0; i<length; i++){
                    filter = filter + this.company.origin_id[i]
                    if(length>1 && i<length-1){
                        filter = filter + ','
                    }
                }
            }
            if(this.company.status_id!=undefined){
                count = count+1
                filter = filter + '&filter[status_id]=' + this.company.status_id
            }
            //date
            if(this.company.created_at.length==2){
                count = count+1
                filter = filter + '&filter[created_at_between]=' + this.company.created_at[0] + ',' + this.company.created_at[1]
            }
            if(this.company.updated_at.length==2){
                count = count+1
                filter = filter + '&filter[updated_at_between]=' + this.company.updated_at[0] + ',' + this.company.updated_at[1]
            }

            //save
            localStorage.setItem('selectorFiltersAgencies', JSON.stringify(this.company));
            localStorage.setItem('filtersAgencies', JSON.stringify(filter.slice(1,filter.length)));
            localStorage.setItem('filtersAgenciesLength', count)

            this.$nextTick(() => {
                this.$emit("filterAgencies", false);
            })
        }
    },
    created(){
        if(localStorage.getItem('selectorFiltersAgencies')!=undefined){
            this.quotation = JSON.parse(localStorage.getItem('selectorFiltersAgencies'))
        }
    },
  }
</script>